<script lang="ts" setup>
import imgScrollToTop from './scrolltotop.svg';

const scrollToTop = () =>
  scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
</script>
<template>
  <button @click="scrollToTop">
    <img :src="imgScrollToTop" alt="↑ページ上部へ" loading="lazy" />
  </button>
</template>
